module.exports = __webpack_public_path__ + "static/media/data1.52fb255d.png";